import { render, staticRenderFns } from "./InstagramFollow.vue?vue&type=template&id=34cefd69&"
import script from "./InstagramFollow.vue?vue&type=script&lang=ts&"
export * from "./InstagramFollow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports